import React from 'react'
import { Provider } from 'react-redux'
import store from 'state'

// import { Socket } from 'react-socket-io'
// import { SOCKET_ADDRESS } from './config'

// console.log("SOCKET_ADDRESS",SOCKET_ADDRESS)

const Providers: React.FC = ({ children }) => {
  return (
    <Provider store={store}>
        {children}
    </Provider>
  )
}

/*
const Providers: React.FC = ({ children }) => {
  return (
    <Provider store={store}>
      <Socket uri={SOCKET_ADDRESS} options={{ transports: ['websocket'] }}>
        {children}
      </Socket>
    </Provider>
  )
}
*/

export default Providers
